import * as z from "zod";
import { InlineLockAttrsSchema } from "./lock-types-schema";

/**
 * Variable node - references a dynamic value.
 */
const VariableNodeSchema_ = z.object({
  type: z.literal("variable"),
  instanceId: z.string(),
  selectionKey: z.string(),
  selectionLabel: z.string(),
  itemKey: z.string().nullish(),
  itemLabel: z.string().nullish(),
  config: z.record(z.string(), z.unknown()).optional(),
  lock: InlineLockAttrsSchema.optional(),
  /** Whether the node has a validation error (e.g., missing required config) */
  hasError: z.boolean().optional(),
});

/** Base type from schema inference (no index signature). Exported for use with Omit. */
export type VariableNodeBase = z.infer<typeof VariableNodeSchema_>;

/** Full type with index signature for FlowContentNode compatibility */
export type VariableNode = VariableNodeBase & { [key: string]: unknown };

/** Attrs type for tiptap (Omit done on base type before index signature) */
export type VariableNodeAttrs = Omit<VariableNodeBase, "type">;

export const VariableNodeSchema: z.ZodType<VariableNode> = VariableNodeSchema_;

/**
 * Type guard for variable nodes.
 */
export function isVariableNode(node: unknown): node is VariableNode {
  return (
    typeof node === "object" &&
    node !== null &&
    (node as Record<string, unknown>).type === "variable"
  );
}
